import { render, staticRenderFns } from "./distraction-type-select.vue?vue&type=template&id=1b0fa327&"
import script from "./distraction-type-select.vue?vue&type=script&lang=js&"
export * from "./distraction-type-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports